import { useEffect } from 'react';
import isBrowser from 'is-browser';

/**
 * Hook that injects @page styles for PDF printing
 * Appends a style tag to the document head with print-specific CSS
 */
export const usePrintPageStyles = (isPrintMode: boolean) => {
  useEffect(() => {
    if (!isPrintMode || !isBrowser) return;

    const styleId = 'print-page-styles';
    let styleElement = document.getElementById(styleId) as HTMLStyleElement;

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    styleElement.textContent = `
      @page {
        margin: 0;
        size: auto;
      }
    `;

    return () => {
      if (isBrowser && styleElement && styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement);
      }
    };
  }, [isPrintMode]);
};
